var exports = {
  "HG": "xcc377c0b--a1843a--builder-call-reasons",
  "Qs": "xcc377c0b--a1843a--content",
  "wx": "xcc377c0b--a1843a--header",
  "Kk": "xcc377c0b--a1843a--icon",
  "Ot": "xcc377c0b--a1843a--reasons",
  "l": "xcc377c0b--a1843a--reason",
  "o1": "xcc377c0b--a1843a--actions",
};

module.exports = exports;
